import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import WebDevelopmentPage from './pages/services/WebDevelopmentPage';
import AppDevelopmentPage from './pages/services/AppDevelopmentPage';
import SoftwareDevelopmentPage from './pages/services/SoftwareDevelopmentPage';
import DataAnalyticsPage from './pages/services/DataAnalyticsPage';
import DigitalMarketingPage from './pages/services/DigitalMarketingPage';
import SEOServicesPage from './pages/services/SEOServicesPage';
import SocialMediaPage from './pages/services/SocialMediaPage';
import ContentMarketingPage from './pages/services/ContentMarketingPage';
import PPCAdvertisingPage from './pages/services/PPCAdvertisingPage';
import AISolutionsPage from './pages/services/AISolutionsPage';
import ProcessAutomationPage from './pages/services/ProcessAutomationPage';
import MachineLearningPage from './pages/services/MachineLearningPage';
import ChatbotDevelopmentPage from './pages/services/ChatbotDevelopmentPage';

import AutomotivePage from './pages/industries/AutomotivePage';
import IndustrialPage from './pages/industries/IndustrialPage';
import HighTechPage from './pages/industries/HighTechPage';

import MedicalDevicesPage from './pages/industries/MedicalDevicesPage';
import PharmaPage from './pages/industries/PharmaPage';
import PayerProviderPage from './pages/industries/PayerProviderPage';

import BankingPage from './pages/industries/BankingPage';
import CapitalMarketsPage from './pages/industries/CapitalMarketsPage';
import InsurancePage from './pages/industries/InsurancePage';

import ExpenseManagementPage from './pages/products/ExpenseManagementPage';
import BulkWhatsappPage from './pages/products/BulkWhatsappPage';

import LeadershipPage from './pages/LeadershipPage';
import BlogPage from './pages/BlogPage';
import BlogDetailsPage from './pages/BlogDetailsPage';
import CareersPage from './pages/CareersPage';
import ContactPage from './pages/ContactPage';
import Footer from './components/Footer';
import './index.css';

function App() {
  const [showScroll, setShowScroll] = useState(false);

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 400) {
      setShowScroll(true)
    } else if (showScroll && window.pageYOffset <= 400) {
      setShowScroll(false)
    }
  };

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.addEventListener('scroll', checkScrollTop)
    return () => {
      window.removeEventListener('scroll', checkScrollTop)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showScroll]);


  return (
    <Router>
      <div className="font-sans text-gray-900 bg-white">
        <Navbar />

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          {/* Service Routes - Digital Business */}
          <Route path="/services/web-development" element={<WebDevelopmentPage />} />
          <Route path="/services/app-development" element={<AppDevelopmentPage />} />
          <Route path="/services/software-development" element={<SoftwareDevelopmentPage />} />
          <Route path="/services/data-analytics" element={<DataAnalyticsPage />} />

          {/* Service Routes - Digital Marketing */}
          <Route path="/services/digital-marketing" element={<DigitalMarketingPage />} />
          <Route path="/services/seo-services" element={<SEOServicesPage />} />
          <Route path="/services/social-media-marketing" element={<SocialMediaPage />} />
          <Route path="/services/content-marketing" element={<ContentMarketingPage />} />
          <Route path="/services/ppc-advertising" element={<PPCAdvertisingPage />} />

          {/* Service Routes - AI & Automation */}
          <Route path="/services/ai-solutions" element={<AISolutionsPage />} />
          <Route path="/services/process-automation" element={<ProcessAutomationPage />} />
          <Route path="/services/machine-learning" element={<MachineLearningPage />} />
          <Route path="/services/chatbot-development" element={<ChatbotDevelopmentPage />} />

          {/* Industry Routes - Financial Services */}
          <Route path="/industries/banking" element={<BankingPage />} />
          <Route path="/industries/capital-markets" element={<CapitalMarketsPage />} />
          <Route path="/industries/insurance" element={<InsurancePage />} />

          {/* Industry Routes - Manufacturing */}
          <Route path="/industries/automotive" element={<AutomotivePage />} />
          <Route path="/industries/industrial" element={<IndustrialPage />} />
          <Route path="/industries/high-tech" element={<HighTechPage />} />

          {/* Industry Routes - Healthcare & Life Sciences */}
          <Route path="/industries/medical-devices" element={<MedicalDevicesPage />} />
          <Route path="/industries/pharma" element={<PharmaPage />} />
          <Route path="/industries/payer-provider" element={<PayerProviderPage />} />

          {/* Product Routes */}
          <Route path="/products/expense-management" element={<ExpenseManagementPage />} />
          <Route path="/products/bulk-whatsapp" element={<BulkWhatsappPage />} />

          {/* Other Pages */}
          <Route path="/leadership" element={<LeadershipPage />} />
          <Route path="/sustainability" element={<div className="min-h-screen pt-20 flex items-center justify-center text-2xl text-slate-600">Sustainability - Coming Soon</div>} />
          <Route path="/corporate-responsibility" element={<div className="min-h-screen pt-20 flex items-center justify-center text-2xl text-slate-600">Corporate Responsibility - Coming Soon</div>} />
          <Route path="/case-studies" element={<div className="min-h-screen pt-20 flex items-center justify-center text-2xl text-slate-600">Case Studies - Coming Soon</div>} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:id" element={<BlogDetailsPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>

        <Footer />

        {/* Back to Top Button */}
        {showScroll && (
          <button
            onClick={scrollTop}
            className="fixed bottom-10 right-10 bg-secondary text-white p-3 rounded-full shadow-lg hover:bg-blue-600 transition duration-300 z-50 animate-fade-in"
            aria-label="Back to top"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 10l7-7m0 0l7 7m-7-7v18"></path></svg>
          </button>
        )}
      </div>
    </Router>
  );
}

export default App;
